import React from 'react';
//import image from '../images/voa-image.png';
import '../css/card.css';

const Card = ({
  name,
  website,
  imageUrl,
  autoGeneratedLogo,
  programs,
  onCardSelect,
}) => {
  return (
    <div className="card">
      <a
        onClick={() => onCardSelect({ name, website, imageUrl, programs })}
        className="stretched-link text-decoration-none"
      >
        <h5 className="card-title">{`${
          autoGeneratedLogo == 1 ? '' : name
        }`}</h5>
        <div className="card-image-background-color">
          <img src={imageUrl} className="card-img-top" alt={name} />
          <div></div>
        </div>
        <div className="card-body">
          <p className="card-text">{website}</p>
        </div>
      </a>
    </div>
  );
};

export default Card;
